import React, { Fragment } from 'react';
import { Script } from 'gatsby';

const RootElement = ({ children }) => {
  return (
    <Fragment>
        
      <div>{children}</div>
    </Fragment>
  );
};

export default RootElement;